import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const fragments = [
    { label: 'Blog', file: 'blog' },
    { label: 'FAQ', file: 'faq' },
    { label: 'Documentation', file: 'documentation' },
    { label: 'Privacy Policy', file: 'privacy-policy' },
    { label: 'Terms of Service', file: 'terms-of-service' },
    { label: 'Contact Us', file: 'contact-us' },
];

export default function ResponseFooter() {
    const [selectedFragment, setSelectedFragment] = useState(null);
    const [fragmentTitle, setFragmentTitle] = useState('');
    const [loading, setLoading] = useState(false);

    const fragmentTitles = {
        'blog': 'Blog',
        'faq': 'Frequently Asked Questions',
        'documentation': 'Documentation',
        'privacy-policy': 'Privacy Policy',
        'terms-of-service': 'Terms of Service',
        'contact-us': 'Contact Us',
    };

    const handleLinkClick = async (file) => {
        setLoading(true);
        try {
            const response = await fetch(`/fragments/${file}.html`);
            if (!response.ok) throw new Error('Failed to load fragment');
            const html = await response.text();
            const title = fragmentTitles[file] || file;
            setFragmentTitle(title);
            setSelectedFragment(html);
        } catch (error) {
            console.error('Error loading fragment:', error);
            setFragmentTitle(file);
            setSelectedFragment(`<p>Loading...</p>`);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseDialog = () => {
        setSelectedFragment(null);
    };

    return (
        <>
            <Paper
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1000,
                    bgcolor: '#1976d2',
                    borderRadius: 0,
                }}
                elevation={3}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 1,
                        py: 0.5,
                    }}
                >
                    {fragments.map((item) => (
                        <Button
                            key={item.file}
                            onClick={() => handleLinkClick(item.file)}
                            sx={{
                                color: 'white',
                                fontSize: '0.75rem',
                                textTransform: 'none',
                                px: 1.5,
                                py: 0.75,
                                minWidth: 'auto',
                                '&:hover': {
                                    backgroundColor: 'rgba(255,255,255,0.15)',
                                },
                            }}
                        >
                            {item.label}
                        </Button>
                    ))}
                    <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', ml: 2, fontSize: '0.7rem' }}>
                        Updated: 2026-04-09
                    </Typography>
                </Box>
            </Paper>

            <Dialog
                open={Boolean(selectedFragment)}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseDialog();
                    }
                }}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ bgcolor: '#000000', color: 'white' }}>
                    {fragmentTitle}
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseDialog}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: 'white',
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {loading ? (
                        <Box sx={{ p: 4, textAlign: 'center', bgcolor: '#f5f5f5' }}>
                            <p>Loading...</p>
                        </Box>
                    ) : (
                        <Box
                            sx={{
                                bgcolor: '#f5f5f5',
                                borderRadius: 1,
                                p: 2,
                            }}
                            dangerouslySetInnerHTML={{ __html: selectedFragment || '' }}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="inherit">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}